import { defineStore } from 'pinia';

import type { CreditMemo } from '@stuut/api/models';

interface State {
  creditMemos: CreditMemo[];
}

export const useCreditMemos = defineStore('credit-memos', {
  getters: {
    getById: (state) => {
      return (id: string) =>
        state.creditMemos.find((creditMemo) => creditMemo.id === id) as CreditMemo | undefined;
    },
  },

  state: (): State => ({
    creditMemos: [],
  }),
});

export default useCreditMemos;
